import $ from 'jquery';

$(_ => {
  $('.js-one-click-reveal').one('click', event => {
    const $clicked = $(event.target);
    const $target = $($clicked.attr('data-reveal-target'));

    const $form = $clicked.closest('form');
    const $firstInput = $form.find('input').not($clicked).first();

    window.requestAnimationFrame(_ => {
      $clicked.hide();
      $target.show();
      $firstInput.focus();
    });

  });
});